// Maximum file size for uploads (10MB in bytes)
export const MAX_FILE_SIZE = 20 * 1024 * 1024
